import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import {
	app,
	auth,
	price,
	profile,
	alert,
	contact,
	dict,
	form,
	audit,
	payment,
	user,
	unit,
	notification,
	table,
	job,
	applicationPane,
	ngoSignup,
	location,
	printFrame,
	event,
	volunteer,
	program,
	caseNotePane,
} from './modules';
import axios from 'axios';

import { RootState } from './types';
import { abilityPlugin } from './plugins';
import { featurePlugin } from './plugins';
import { ProfileActionKeys } from './modules/profile';
import { UnitActionKeys } from './modules/unit';
import { TableActionKeys } from './modules/table';
import { AppActionKeys } from './modules/app';
import { UserActionKeys } from './modules/user';

Vue.use(Vuex);

const store: StoreOptions<RootState> = {
	plugins: [abilityPlugin, featurePlugin],

	state: {
		isMiniDrawer: false,
		isMobileDrawer: false,
		userID: 1,
		useDummyData: false,
	},

	mutations: {
		toggleDrawer(state, val) {
			const temp = state.isMiniDrawer;
			if (val) state.isMiniDrawer = val;
			else state.isMiniDrawer = !temp;
			return state;
		},
		toggleMobileDrawer(state, val) {
			const temp = state.isMobileDrawer;
			if (val) state.isMobileDrawer = val;
			else state.isMobileDrawer = !temp;
			return state;
		},
		updateUseDummyData(state, val) {
			state.useDummyData = val;
		},
	},

	actions: {
		saveCustomFields({ dispatch }, newField) {
			axios
				.post(`/form/custom-fields`, newField)
				.then(function() {
					dispatch('loadCustomFields');
				})
				.catch(function(error) {
					console.error('error saving custom fields', error);
				});
		},
		updateCustomFields({ dispatch }, config) {
			axios
				.put(`/form/custom-fields/${config.id}`, config.newField)
				.then(function() {
					dispatch('loadCustomFields');
				})
				.catch(function(error) {
					console.error('error updating custom fields', error);
				});
		},
		resetModuleState({ dispatch }) {
			dispatch(`table/${TableActionKeys.resetState}`);
			dispatch(`profile/${ProfileActionKeys.resetState}`);
			dispatch(`unit/${UnitActionKeys.resetState}`);
			dispatch(`app/${AppActionKeys.resetState}`);
			dispatch(`user/${UserActionKeys.resetState}`);
			dispatch(`contact/${UserActionKeys.resetState}`);
		},
	},

	modules: {
		app,
		auth,
		price,
		profile,
		alert,
		contact,
		dict,
		form,
		audit,
		payment,
		user,
		unit,
		notification,
		table,
		job,
		applicationPane,
		caseNotePane,
		ngoSignup,
		location,
		printFrame,
		event,
		volunteer,
		program,
	},
};

export default new Vuex.Store<RootState>(store);
